import "./sentry"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { createBrowserRouter, RouterProvider } from "react-router-dom"

import "./index.css"
import App from "./App.tsx"
import { AdminLogin } from "./pages/collection/AdminLogin"
import { AdminDashboard } from "./pages/collection/AdminDashboard"
import { CollectionLayout } from "./pages/collection/CollectionLayout"

const sectionRoutes = ["about", "services", "gallery", "contact", "booking"]

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  ...sectionRoutes.map((section) => ({
    path: `/${section}`,
    element: <App />,
  })),
  {
    path: "/collection",
    element: <CollectionLayout />,
    children: [
      {
        path: "admin",
        element: <AdminLogin />,
      },
      {
        path: "dashboard",
        element: <AdminDashboard />,
      },
    ],
  },
])

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
)
